import { BrowserModule, TransferState } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { app_routing } from './app.routing';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LightboxModule } from 'angular2-lightbox';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { CommonThemeModule, RavenErrorHandler } from './common-theme/index';
import { AgmCoreModule } from '@agm/core';

// Material
import {
  MatSidenavModule,
  MatListModule,
  MatInputModule,
  MatDialogModule,
  MatSelectModule,
  MatTooltipModule,
  MatButtonModule,
  MatSnackBarModule
} from '@angular/material';

// Translate
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { exportTranslateStaticLoader } from './common-theme/i18n/translate-browser-loader.service';

// Components
import { HomeComponent } from './home/home.component';
import { PartnersComponent } from './partners/partners.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ServicesComponent } from './services/services.component';
import { HousesRouterComponent } from './houses/houses-router.component';
import { HousesComponent } from './houses/houses.component';
import { HouseDetailsComponent } from './houses/house-details.component';
import { PropertyComponent } from './shared/property/property.component';
import { TestimonialsComponent } from './shared/testimonials/testimonials.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { ProjectDetailsComponent } from './portfolio/project-details.component';
import { ContactComponent } from './contact/contact.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutUsComponent,
    TestimonialsComponent,
    ServicesComponent,
    HousesRouterComponent,
    HousesComponent,
    HouseDetailsComponent,
    PartnersComponent,
    PortfolioComponent,
    ProjectDetailsComponent,
    PropertyComponent,
    ContactComponent
  ],
  imports: [
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDqK0aUZbZtx31c8Ic6qQOCLctffxhG4Dk'
    }),
    CommonThemeModule,
    BrowserModule.withServerTransition({ appId: 'proiecteimobiliaresoava' }),
    FormsModule,
    BrowserAnimationsModule,
    LightboxModule,
    FlexLayoutModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: exportTranslateStaticLoader,
        deps: [HttpClient, TransferState]
      }
    }),
    TransferHttpCacheModule,
    app_routing,

    // Material
    MatSidenavModule,
    MatListModule,
    MatSnackBarModule,
    MatInputModule,
    MatTooltipModule,
    MatButtonModule,
    MatSelectModule,
    MatDialogModule
  ],
  providers: [
    { provide: ErrorHandler, useClass: RavenErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts